module.exports = __webpack_public_path__ + "img/presupuesto.6480f725.svg";